import axios from "axios";
import { createApi } from "@reduxjs/toolkit/query/react";
import { authEndpoints } from "./endpoints/authEndpoints";
import { dataEndpoints } from "./endpoints/dataEndpoints";

const axiosInstance = axios.create();
const axiosBaseQuery =
  ({ baseUrl }) =>
  async ({ url, method, data, params }) => {
    const accessToken = sessionStorage.getItem("accessToken");
    const refreshToken = sessionStorage.getItem("refreshToken");

    try {
      const result = await axiosInstance({
        url: baseUrl + url,
        method,
        data,
        params,
        headers: {
          Authorization: `Bearer ${accessToken ? accessToken : refreshToken}`,
          //   'Content-Type': 'multipart/form-data',
          "Cache-Control": "no-cache",
        },
      });
      return { data: result.data };
    } catch (axiosError) {
      let err = axiosError;

      if (err.response?.status === 401) {
        if (typeof window !== "undefined") {
          localStorage.setItem(
            "redirectAfterLogin",
            window.location.pathname + window.location.search
          );
        }
        sessionStorage.removeItem("accessToken");
        sessionStorage.removeItem("refreshToken");

        window.location.href = "/sign-in";

        return {
          error: {
            status: 401,
            data: "Unauthorized - Redirecting to sign-in",
          },
        };
      }

      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
  }),
  endpoints: (builder) => ({
    ...authEndpoints(builder),
    ...dataEndpoints(builder),
  }),
});

export const {
  // auth
  useLoginMutation,
  useLogoutMutation,
  useSignupMutation,
  useVerifyOTPMutation,
  useResendOTPMutation,
  //Search company
  usePostSearchCompanyMutation,
  usePostFirstUpdateInfoMutation,
  //profile
  useGetUserInfoQuery,
  useUpdateUserInfoMutation,
  usePostUpdateAvatarMutation,
  // Quest
  useGetQuestQuestionsDetailsQuery,
  useLazyGetQuestListQuery,
  useGetTakeQuestQuery,
  usePostTakeQuestPracticeMutation,
  usePostAnswerMutation,
  useGetQuestDetailsQuery,
  useLazyGetTakeQuestPracticeQuery,
  usePostFileTakeQuestMutation,
  usePostTakeQuestReviewingMutation,
  usePostActionEditQuestDetailsMutation,

  //ondemand
  useGetListObjectivesQuery,
  useGetListObjectivesQuestionQuery,
  usePostGenObjectivesByAIMutation,
  useGetListSegmentionQuery,
  usePostOndemandMutation,
  useGetListBusinessLocationQuery,
  useGetListBusinessLocationLatLongQuery,
  usePostFileUploadMutation,
  usePostAIGenInfoMutation,
  usePostAIGenQuestionMutation,
  usePostCalculatorIncentiveMutation,
  usePostCalculatorTokenXPMutation,
  usePostCalculatorMysteryShopperMutation,

  //Quest Result
  // usePostQuestTakeResultMutation,
  useGetQuestTakeResultQuery,

  //Quest QR Code
  useGenQuestQRCodeMutation,
  //Performance
  useGetPerformanceQuery,

  //Location
  usePostFindNewLocationMutation,
  useGetPerformanceDetailsQuery,

  //Top up
  usePostTopUpMutation,
  useGetTopUpHistoryQuery,
} = apiSlice;
